import { render, staticRenderFns } from "./PaginaTabelleCompensi.vue?vue&type=template&id=b2afe200&"
import script from "./PaginaTabelleCompensi.vue?vue&type=script&lang=js&"
export * from "./PaginaTabelleCompensi.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTabelleCompensi.vue?vue&type=style&index=0&id=b2afe200&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports